(function(){
  'use strict';

  function ready(fn){
    if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',fn,{once:true});
    else fn();
  }

  function callGlobal(name){
    var fn=window[name];
    if(typeof fn==='function'){
      try{ fn(); }catch(e){}
    }
  }

  function initPdpMobile(){
    var sidebar=document.getElementById('pmy-sidebar');
    var fab=document.getElementById('mobile-sticky-checkout');
    var footer=document.querySelector('.main-footer');

    if(sidebar && sidebar.dataset.pmyMobileAuditBound!=='1'){
      sidebar.dataset.pmyMobileAuditBound='1';

      sidebar.addEventListener('click',function(e){
        if(e.target===sidebar && sidebar.classList.contains('modal-open')) callGlobal('closeMobileModal');
      });

      if(fab){
        fab.addEventListener('click',function(){
          window.setTimeout(function(){
            var close=sidebar.querySelector('.close-modal-pmy');
            if(close && close.focus) close.focus({preventScroll:true});
          },30);
        });
      }
    }

    if(fab && footer && fab.dataset.pmyFooterCollision!=='1'){
      fab.dataset.pmyFooterCollision='1';
      var ticking=false;

      function updateFab(){
        ticking=false;
        if(window.innerWidth>767){
          fab.style.removeProperty('--pmy-pdp-fab-lift');
          return;
        }
        var rect=footer.getBoundingClientRect();
        var base=16;
        var lift=base;
        if(rect.top<window.innerHeight && rect.bottom>0){
          lift=Math.max(base,Math.round(window.innerHeight-rect.top+12));
        }
        fab.style.setProperty('--pmy-pdp-fab-lift',lift+'px');
      }

      function schedule(){
        if(ticking)return;
        ticking=true;
        window.requestAnimationFrame(updateFab);
      }

      window.addEventListener('scroll',schedule,{passive:true});
      window.addEventListener('resize',schedule,{passive:true});
      if('ResizeObserver' in window) new ResizeObserver(schedule).observe(footer);
      updateFab();
    }
  }

  function initEscapeHandling(){
    if(document.documentElement.dataset.pmyMobileEscapeBound==='1') return;
    document.documentElement.dataset.pmyMobileEscapeBound='1';

    document.addEventListener('keydown',function(e){
      if(e.key!=='Escape')return;

      var sidebar=document.getElementById('pmy-sidebar');
      if(sidebar && sidebar.classList.contains('modal-open')){
        callGlobal('closeMobileModal');
        return;
      }

      var lightbox=document.getElementById('pmy-lightbox');
      if(lightbox && getComputedStyle(lightbox).display!=='none'){
        callGlobal('closeLightbox');
        return;
      }

      var gallery=document.getElementById('pmy-full-gallery');
      if(gallery && getComputedStyle(gallery).display!=='none'){
        callGlobal('closeFullGallery');
      }
    });
  }

  function init(){
    initPdpMobile();
    initEscapeHandling();
  }

  ready(init);
  document.addEventListener('shopify:section:load',init);
})();